/**
 * Object for handle appearing elements in viewport. For GA events, for example
 */
window.bambooIntersectionObserverHelper = {
  elements: {},

  viewedProducts: [],

  initInProgress: false,

  repeatInit: false,

  reinit() {
    if (this.initInProgress) {
      this.repeatInit = true;
    }

    this.initInProgress = true;


    const elements = document.getElementsByClassName('bamboo-viewport');

    this.addElementsArrayToObserve(elements);

    this.initInProgress = false;

    if (this.repeatInit) {
      this.repeatInit = false;

      this.reinit();
    }
  },

  init() {
    this.reinit();


    // Configuration to observe the body element changes.
    const observerConfig = {
        childList: true,
        subtree: true,
    };

    // Callback on change the body element
    const bodyChanged = () => {
      this.reinit();
    };

    // New observer object
    const observer = new MutationObserver(bodyChanged);

    // Start the observation
    observer.observe(document.body, observerConfig);


    // Send one event with batch of viewed products
    document.addEventListener("visibilitychange", () => {
      if (document.visibilityState === 'visible') {
        return;
      }

      bambooIntersectionObserverHelper.sendEvents({eventAction: 'view_item_list'});
    });

  	// For Safary
    window.addEventListener("pagehide", () => {
      bambooIntersectionObserverHelper.sendEvents({eventAction: 'view_item_list_safari'});
    }, false);

	// For some mobile behavior
	setInterval(() => bambooIntersectionObserverHelper.sendEvents({eventAction: 'view_item_list_time'}), 60000);
  },

  addElementsArrayToObserve(elements) {
    const observerOptions = {
      root: null,
      rootMargin: "0px",
      threshold: 0.98, // No 1.0 because sometimes threshold can't reach this value at all
    };


    for (let oneElement of elements) {
      let observer;

      observer = new IntersectionObserver(bambooIntersectionObserverHelper.handleIntersect, observerOptions);

      observer.observe(oneElement);

      oneElement.classList.remove('bamboo-viewport');
      oneElement.classList.add('bamboo-viewport-initialized');
    }
  },

  addToObserveById(id) {
    const el = document.getElementById(id);

    this.addElementsArrayToObserve([el]);
  },

  /**
   * We consider element as shown to user if it is going from invisible to visible state.
   * And we are give some threshold time to element if it is moving in visible port of screen.
   */
  handleIntersect(elements) {
    // Time threshold for repeatable view element when slides changed
    const viewInterval = 2000;

    for (let oneElement of elements) {
      // Can't manage elements without id
      if (!oneElement.target.id) {
        console.warn(`Bamboo: intersection element without id. Classes: ${oneElement.target.className}`);

        return;
      }

      // Add elements to list of tracking elements
      if (!bambooIntersectionObserverHelper.elements[oneElement.target.id]) {
        bambooIntersectionObserverHelper.elements[oneElement.target.id] = {
          previousIsIntersecting: null,
          currentIsIntersecting: oneElement.isIntersecting,
          eventTime: oneElement.time,
          lastCallCustomEventTime: oneElement.time - viewInterval, // Init with -1 sec time
        }
      } else {
        bambooIntersectionObserverHelper.elements[oneElement.target.id].previousIsIntersecting =
          bambooIntersectionObserverHelper.elements[oneElement.target.id].currentIsIntersecting;

        bambooIntersectionObserverHelper.elements[oneElement.target.id].currentIsIntersecting = oneElement.isIntersecting;

        bambooIntersectionObserverHelper.elements[oneElement.target.id].eventTime = oneElement.time;
      }

      // Condition to fire processViewedElement method
      if (
        !bambooIntersectionObserverHelper.elements[oneElement.target.id].previousIsIntersecting
        && bambooIntersectionObserverHelper.elements[oneElement.target.id].currentIsIntersecting

        // Fire custom event only if more second beetween last call
        && (
          		bambooIntersectionObserverHelper.elements[oneElement.target.id].eventTime
        		- bambooIntersectionObserverHelper.elements[oneElement.target.id].lastCallCustomEventTime
           ) >= viewInterval
      ) {
        bambooIntersectionObserverHelper.elements[oneElement.target.id].lastCallCustomEventTime = oneElement.time;

      	bambooIntersectionObserverHelper.processViewedElement(oneElement.target);
      }
    }
  },

  processViewedElement(el) {
    if (!el.dataset.product) {
      console.warn(`bambooIntersectionObserverHelper: Element without proper data "product" attribute. Classes: ${el.className}`);

      return;
    }

    const product = JSON.parse(el.dataset.product);

    this.viewedProducts.push({
      id: product.id,
      name: product.name,
      category: product.category,
      price: product.price
    });
  },

  sendEvents() {
    const products = this.viewedProducts.splice(0);

    if (products.length === 0) {
      return;
    }

    const impressions = [];

    products.forEach(oneProduct => {
      impressions.push(oneProduct);
    });

    window.dataLayer.push({
	  ecommerce: {
		currencyCode: 'UZS',
		impressions,
	  },
      event: 'ecomm_viewList',
      event_category: 'ecomm_event',
      event_action: 'impression_view',
      event_label: 'eec_view'
    });

  }
};


bambooIntersectionObserverHelper.init();
